import { render, staticRenderFns } from "./relatorioCadTomador.vue?vue&type=template&id=25a6445e"
import script from "./relatorioCadTomador.vue?vue&type=script&lang=js"
export * from "./relatorioCadTomador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports